import ApiService from '@api/api-service';
import PaymentiFrame from '../vendor/bluefin';
import AjaxLoader from './ajax-loader/ajax-loader';
import store from '@stores/cart/cart-store';

export default class AddPayment {
    constructor(options) {
        this.options = options;
        this.api = new ApiService(options.urlPath);

        this.loader = null;

        this.initializeElements();
        if (!this.frameSettings || this.$paymentFrame.length) {
            return true
        }

        this.setupLoader();
        this.setupFrame();
        this.setEvents();
        this.setScrolling();
    }

    initializeElements() {
        this.$container = $(this.options.containerId);
        this.$formContainer = this.$container.find('[data-region="addressForm"]');
       // this.$form = this.$container.find('[data-control="form"]');
        this.$frameSettings = $('#paymentSettings');
        //console.log('settings' ,this.$frameSettings );
        this.$paymentLoader = this.$container.find(this.options.paymentLoaderId);
        this.$savePayment = this.$container.find(this.options.savePaymentId);
        this.$savePaymentError = this.$container.find(this.options.savePaymentErrorId);
        this.$updateAutoshipCheckbox = this.$container.find(this.options.updateAutoshipCheckboxId);

        if (this.$frameSettings.length) {
            this.frameSettings = JSON.parse(this.$frameSettings.html());
            this.$paymentFrame = this.$container.find('#' + this.frameSettings.iframeId);
        }
    }

    async savePaymentMethod(res, params) {
        let dstransid = '';
        let authenticationvalue = '';
        if (res.ddds_result != null) {
            if (res.ddds_result.ddds_status == 'N') {
                alert("Unable to validate payment method. Please check card number, expiration date or CVV");
                return;
            }

            //if (res.ddds_result.ddds_challenged) {
                if (res.ddds_result.ddds_dstransid != null) {
                    dstransid = res.ddds_result.ddds_dstransid;
                }
                if (res.ddds_result.ddds_authenticationvalue != null) {
                    authenticationvalue = res.ddds_result.ddds_authenticationvalue;
                }
            //}
        }
        const { success, data, error } = await this.api.post({
            //AddressId: this.options.addressId,
            Id:res.id,
            eToken: res.eToken,
            DddsAmexDsTransId: res.ddds_result.amexDsTransId,
            DddsAttempted:res.ddds_result.ddds_attempted,
            DddsAuthenticationValue: res.ddds_result.ddds_authenticationvalue,
            DddsChallenged:res.ddds_result.ddds_challenged,
            DddsDsTransId: res.ddds_result.ddds_dstransid,
            DddsEci: res.ddds_result.ddds_eci,
            DddsStatus: res.ddds_result.ddds_status,
            DddsVersion: res.ddds_result.ddds_version,
            DeliveryTimeFrame: params.ddds_params.deliveryTimeFrame,
            ReOrderItemsInd: params.ddds_params.reorderItemsInd,
            ShipIndicator: params.ddds_params.shipIndicator,
            ScaIndicator:res.ddds_result.scaIndicator,
            AcsTransId:res.ddds_result.acsTransId,
            CardBrand:res.ddds_result.card_brand,
            CardHolderName:params.ddds_params.cardHolderName,
            BillingAddressLine1:params.ddds_params.billingLine1,
            BillingAddressLine2:params.ddds_params.billingLine2,
            BillingCity: params.ddds_params.billingCity,
            BillingState: params.ddds_params.billingState,
            BillingZip: params.ddds_params.billingPostCode,
            BillingCountry: params.ddds_params.billingCountry
        });

        if(success) {
            //window.location.href = window.location.href;
            console.log('data for cards dd', data);
            let paymentId = data.PaymentMethodResultModel.PaymentMethodId
            this.options.setupMethods(data, true, paymentId);
        } else if(error) {
            this.setError(error);
        }

        if(this.loader) this.loader.active = false;
    }

    setupLoader() {
        if(this.$paymentLoader.length) {
            this.loader = new AjaxLoader(this.$paymentLoader, {
                replaceOriginEl: false,
                size: 'xs'
            });

            this.loader.render();
        }
    }

    setupFrame() {
        this.frame = new PaymentiFrame(this.frameSettings);
    }

    setError(error) {
        if(this.$savePaymentError.length) {
            this.$savePaymentError.show().html(error);
        } else {
            alert(error);
        }
    }

    setEvents() {
        let params = {
			'ddds_params': {
				   amount: "0.01",
				   cardHolderName: "", //First Name + Last Name
				   billingLine1: "",
				   billingLine2: "",
				   billingLine3: "",
				  billingPostCode: "",
				  billingCity: "",
				  billingState: "",
				  billingCountry: "840",  // ISO 3166-1 three-digit country codes. e.g. 840 for the United States
                  shipIndicator: "01",
                  deliveryTimeFrame: "04",
                  reorderItemsInd: "01",
                  shipIndicator: "01"
			}
		}


        this.$savePayment.on('click', () => {
            this.$savePaymentError.hide();

            if(this.loader) this.loader.active = true;
            let cardNameInput = $('#addPaymentContainer [data-control="cardHolderName"]');
            let cardNameError = $('#addPaymentContainer [data-region="cardHolderNameError"]');
            if(!cardNameInput[0].checkValidity()) {
                cardNameError.addClass('-visible');
                cardNameInput.parent().addClass('was-validated');
                cardNameInput.attr({ 'aria-invalid': true }).trigger('focus');
                return;
            }
            else {
                cardNameError.removeClass('-visible');
                cardNameInput.parent().removeClass('was-validated');
                cardNameInput.removeAttr('aria-invalid');
                params.ddds_params.cardHolderName = $('#addPaymentContainer [data-control="cardHolderName"]').val();
            }



            let form = this.$container.find('[data-control="form"]');
            if(this.$formContainer.css('display') == 'none'){
                this.loader.active = false;
                console.log('address saved', store.state.billingParty);
                params.ddds_params.billingLine1 = store.getters.billingPartyAddress1;
                params.ddds_params.billingLine2 =store.getters.billingPartyAddress2;
                params.ddds_params.billingState = store.state.billingParty.StateCode;
                params.ddds_params.billingPostCode = store.getters.billingPartyZipPostalCode;
                params.ddds_params.billingCity = store.getters.billingPartyCity;
            }else{
                form.trigger( "submit" );

                if(!form.hasClass('was-validated')){
                    console.log('was vall');

                    let newbillingParty = {
                        'Address1': $('#addPaymentContainer .checkout-address-form [data-control="address"]').val(),
                        'Address2': $('#addPaymentContainer .checkout-address-form [data-control="address2"]').val(),
                        'AddressName': "",
                        'City': $('#addPaymentContainer .checkout-address-form [data-control="city"]').val(),
                        'Country': "United States",
                        'CountryCode': "US",
                        'Email': null,
                        'FirstName': "",
                        'LastName': "",
                        'Name': "",
                        'State': "",
                        'StateCode': $('#addPaymentContainer .checkout-address-form [data-control="select"]').data('value'),
                        'ZipPostalCode': $('#addPaymentContainer .checkout-address-form [data-control="zip"]').val()
                    }
                    params.ddds_params.billingLine1 = $('#addPaymentContainer .checkout-address-form [data-control="address"]').val();
                    params.ddds_params.billingLine2 = $('#addPaymentContainer .checkout-address-form [data-control="address2"]').val();
                    params.ddds_params.billingCity = $('#addPaymentContainer .checkout-address-form [data-control="city"]').val();
                    params.ddds_params.billingState = $('#addPaymentContainer .checkout-address-form [data-control="select"]').data('value');
                    params.ddds_params.billingPostCode = $('#addPaymentContainer .checkout-address-form [data-control="zip"]').val();

                    store.mutations.SET_BILLING_PARTY(newbillingParty);
                    console.log('new bill', store.state.billingParty);
                }else{
                    console.log('not vall');
                    this.loader.active = false;
                    return
                }
            }
          console.log('bluefin params', params);

          if(params.ddds_params.billingLine2 === null){
            params.ddds_params.billingLine2 = "";
          }

            this.frame.encrypt(params)
                .failure((error) => {
                    const message = error?.message;
                    message ? this.setError(message) : alert('Failure:', error);

                    if(this.loader) this.loader.active = false;
                })
                .invalidInput((data) => {
                    const inputs = data?.invalidInputs;
                    if(inputs.length) {
                        const messages = inputs.map((input) => input.message);
                        this.setError(messages[0]);
                    } else {
                        alert('Invalid Input:', data);
                    }

                    if(this.loader) this.loader.active = false;
                })
                .success((res) => {
                    console.log('PayConnect responce', res);
                    console.log('address params', params);
                    if (res.eToken.length > 0) {
                        this.savePaymentMethod(res, params);
                    }
                });
        });
    }

    setScrolling() {
        $('#' + this.frameSettings.iframeId).attr("scrolling", "no");
    }
}
